import { Pill, PillVariants } from "src/base-components/Pill";
import { SkeletonPlaceholder } from "src/base-components/SkeletonPlaceholder";
import { TruncatedIdPill } from "src/base-components/TruncatedIdPill";
import { CaseStatusPill } from "src/cases/common/CaseStatusPill";
import { CaseDeserialized } from "src/cases/queries/casesTypes";
import { getPriorityVariant, getStatusVariant } from "src/cases/utils";

interface CasePageHeaderTitleProps {
  caseData: CaseDeserialized | undefined;
  isLoading: boolean;
  queueName: string | undefined;
}

export const CasePageHeaderTitle: React.FC<CasePageHeaderTitleProps> = ({
  caseData,
  isLoading,
  queueName,
}) => {
  const { case_properties: caseProperties, template_version: templateVersion } =
    caseData?.data || {};
  return (
    <div className="flex items-center gap-x-1.5">
      {queueName ? `${queueName} Queue` : "Queue"}
      <div className="flex items-center gap-x-1.5">
        {isLoading ? (
          <SkeletonPlaceholder height="h-6" width="w-60" />
        ) : (
          caseData && <CaseId value={caseData.data.id} />
        )}
        {isLoading ? (
          <SkeletonPlaceholder height="h-6" width="w-20" />
        ) : (
          caseProperties && (
            <CaseStatusPill
              dataLoc="case-view-status-pill"
              status={String(caseProperties.status || "")}
              subStatus={
                caseProperties.sub_status
                  ? String(caseProperties.sub_status)
                  : undefined
              }
              variant={getStatusVariant(
                String(caseProperties.status || ""),
                templateVersion,
              )}
            />
          )
        )}
        {caseProperties?.priority ? (
          <Pill
            dataLoc="case-view-priority-pill"
            size="sm"
            variant={
              getPriorityVariant(
                String(caseProperties.priority),
                templateVersion,
              ) as PillVariants
            }
          >
            <Pill.Text>{String(caseProperties.priority)}</Pill.Text>
          </Pill>
        ) : null}
      </div>
    </div>
  );
};

const CaseId: React.FC<{ value: string }> = ({ value }) => (
  <div className="max-w-24">
    <TruncatedIdPill feedback="inline-only-checkmark" id={value} />
  </div>
);
